var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,8H6L5,8.74l-3,10.91L2,19.59V4.41L2.41,4H6.59L7,4.41V6H18.59l.41.41V7h2V6l-.29-.71-1-1L19,4H9l-.29-.71-1-1L7,2H2l-.71.29-1,1L0,4V20l.29.71,1,1L2,22H19l.71-.29,1-1,.25-.45,3-11ZM19.11,19.48l-.52.52H4L6.76,10H21.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderOpen);
export default __webpack_public_path__ + "static/1770312069/media/icon-folder-open.5528f5b24dc5916e35c2466958745137.svg";
export { ForwardRef as ReactComponent };